import dateFormat from 'dateformat';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import {AsapMarker} from 'new-constants/common.constants';

export const getMonthTranslationKey = month => {
	if (typeof month === 'number' && month < 10) {
		month = `0${month}`;
	}

	const monthNames = {
		'01': 'pickupDate.shortMonth.january',
		'02': 'pickupDate.shortMonth.february',
		'03': 'pickupDate.shortMonth.march',
		'04': 'pickupDate.shortMonth.april',
		'05': 'pickupDate.shortMonth.may',
		'06': 'pickupDate.shortMonth.june',
		'07': 'pickupDate.shortMonth.july',
		'08': 'pickupDate.shortMonth.august',
		'09': 'pickupDate.shortMonth.september',
		'10': 'pickupDate.shortMonth.october',
		'11': 'pickupDate.shortMonth.november',
		'12': 'pickupDate.shortMonth.december',
	};

	return monthNames['' + month];
};

export const getDateFormattedForPickup = (date, translations = [], todayDateString) => {
	const dateRegex = /(\d{2})\.(\d{2})\.(\d{4})/;

	const todayDateParseResult = dateRegex.exec(todayDateString);

	if (!todayDateParseResult || todayDateParseResult?.length < 4) return null;

	const tomorrowDate = new Date(
		Number(todayDateParseResult[3]),
		Number(todayDateParseResult[2]) - 1,
		Number(todayDateParseResult[1]) + 1
	);
	const tomorrowDateString = dateFormat(tomorrowDate, 'dd.mm.yyyy');

	let text = null;

	if (date === todayDateString) {
		text = getSafeTranslation('pickupDate.today', translations);
	} else if (date === tomorrowDateString) {
		text = getSafeTranslation('pickupDate.tomorrow', translations);
	} else {
		const parseResult = dateRegex.exec(date);
		text = `${parseResult[1]}. ${getSafeTranslation(getMonthTranslationKey(parseResult[2]), translations)}`;
	}

	return text;
};

export const getTimeFormattedForPickup = (time, expectedWait, translations = []) => {
	if (time === AsapMarker) {
		let translation = getSafeTranslation('PickupTime.asapTemplate', translations);

		return translation.replace('{expectedWait}', expectedWait);
	} else {
		return time;
	}
};
